import * as React from 'react'
import { Wrapper } from './style'

const NoDataFound2 = ({ size='small', heading, description }) => {
  return (
    <Wrapper className={`noDataFound ${size}`}>
      {heading && <b>{heading}</b>}
      {description && <p>{description}</p>}
    </Wrapper>
  )
}
export default NoDataFound2
